import { formatCurrency } from '@/helpers/currency';

/**
 * @deprecated use formatCurrency from '@/helpers/currency' directly.
 * Kept as a thin wrapper so existing call sites (InvoicesBillingStats.vue)
 * keep working unchanged.
 */
export default function formatBelgianCurrency(price: number) {
  return formatCurrency(price);
}
